var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unmute-08_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".unmute-08_svg__st1{fill:none}.unmute-08_svg__st3{fill:#35a4dd}.unmute-08_svg__st6{fill:#010202}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.6 279.1v449.7l157.2.2c6.4 0 12.6 1.9 17.9 5.4l287.4 190.3V596.1l-317-317H180.6zM643.1 504.2V98.8l-245.3 160"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.2 214.1H148.1c-17.9 0-32.5 14.6-32.5 32.5v514.7c0 17.9 14.5 32.5 32.5 32.5l179.9.2 329.7 218.3c5.4 3.6 11.7 5.4 17.9 5.4 5.3 0 10.6-1.3 15.4-3.9 10.5-5.7 17.1-16.7 17.1-28.6V661.1l-65-65v328.6L355.7 734.4c-5.3-3.5-11.5-5.4-17.9-5.4l-157.2-.2V279.1h145.6l-65-65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M41.7 9.2c-8.3 0-16.6 3.2-23 9.5C6 31.4 6 52 18.7 64.7l940.6 940.6c6.3 6.3 14.7 9.5 23 9.5s16.6-3.2 23-9.5c12.7-12.7 12.7-33.3 0-46L64.7 18.7c-6.3-6.3-14.7-9.5-23-9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M805.9 335s137.6 137.6 26.9 316.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M708.2 491.2c0-.8 0-1.6-.1-2.4v-144c0 .3 0 .6-.1.8v148.5c0-.2 0-.3.1-.5.1-.7.1-1.6.1-2.4zM691.1 10.5c10.5 5.7 17 16.6 17 28.6v110.8c0 .3 0 .6.1.8V39.5c0-10.2-4.4-20-12.5-26.3-11.1-8.7-26.3-9.1-37.8-1.6L386.1 188.8c-1.3.7-2.6 1.6-3.8 2.5-.6.5-1.2.9-1.8 1.4L657.8 11.9c10-6.5 22.8-7.1 33.3-1.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M708.2 343.2c0-.5 0-1.1-.1-1.6v3.2c.1-.5.1-1.1.1-1.6zM708.2 152.3c0-.5 0-1.1-.1-1.6v3.2c.1-.5.1-1.1.1-1.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M675.6 310.6c-17 0-31 13-32.5 29.7v151c0 7.2 2.3 13.9 6.3 19.3 2 2.7 4.3 5 7 7 5.4 4 12 6.3 19.3 6.3 17 0 30.9-13 32.4-29.6V345.6c0-.3 0-.6.1-.8v-3.2c0-.3 0-.6-.1-.8-1.3-16.9-15.3-30.2-32.5-30.2zM675.6 6.6c-6.2 0-12.4 1.8-17.8 5.3L380.6 192.7c-6.8 6-11.2 14.7-11.2 24.5 0 7.8 2.7 14.9 7.3 20.5 1.4 1.8 3.1 3.4 4.8 4.8 5.6 4.5 12.7 7.3 20.5 7.3 6.1 0 11.9-1.7 16.8-4.6l1.8-1.2L643 99h.1c.1 0 .1.1.1.1v56.2c1.5 16.6 15.4 29.7 32.4 29.7 17.2 0 31.3-13.3 32.5-30.2 0-.3 0-.6.1-.8v-3.2c0-.3 0-.6-.1-.8V39.1c0-11.9-6.5-22.9-17-28.6-4.9-2.6-10.2-3.9-15.5-3.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M708.2 247.7c0-.5 0-1.1-.1-1.6v3.2c.1-.5.1-1 .1-1.6zM643 247.7c0 .8 0 1.6.1 2.4 0 .2 0 .3.1.5v-5.9c0 .2 0 .3-.1.5-.1.9-.1 1.7-.1 2.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M675.6 215.1c-17 0-31 13-32.5 29.7v5.9c1.5 16.6 15.4 29.7 32.5 29.7 17.2 0 31.3-13.3 32.5-30.2 0-.3 0-.6.1-.8v-3.2c0-.3 0-.6-.1-.8-1.3-17-15.3-30.3-32.5-30.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute08);
export default ForwardRef;